/**
 * Тексты реестра экранов на языке интерфейса — в момент показа (agroai-wo4,
 * журнал №1850).
 *
 * Сервер отдаёт панели русские строки реестра: заголовок и текст шага тура
 * (`ui_tools._preset_steps`), названия и описания блоков. Эти же строки
 * лежат в истории беседы и уходят модели обратно (`loop.py`), поэтому сами
 * данные ответа не переводятся (ADR-0019 исключил `/ai/agent/*` из
 * `localizeServerPayload`) — переводится только показ:
 *
 *     surfaceText('title', region.title)   // «Сейчас в районе» → «Hozir tumanda»
 *
 * Сообщение ищется по русскому тексту (`surfaceKey.ts`): строки, которой нет в
 * словаре (текст шага, написанный моделью), — возвращается как есть.
 * Словарь — `surfaceVocab.generated.ts` (`npm run ai-surface:build`).
 */
import type { Message } from '../i18n/define';
import { isSourceLocale, runtimeIntl, tr } from '../i18n/runtime';
import { surfaceId, type SurfaceKind } from './surfaceKey';
import { SURFACE_VOCAB } from './surfaceVocab.generated';

let byId: Map<string, Message> | null = null;

function vocab(): Map<string, Message> {
  if (!byId) byId = new Map((Object.values(SURFACE_VOCAB) as Message[]).map((message) => [message.id, message]));
  return byId;
}

/** Перевод текста реестра; `null` — текста нет в словаре или у языка нет перевода строки. */
export function surfaceTextOrNull(kind: SurfaceKind, text: string | null | undefined): string | null {
  if (!text) return null;
  if (isSourceLocale()) return text;
  const message = vocab().get(surfaceId(kind, text));
  // Перевод загружен — строка есть в каталоге языка; иначе `formatMessage` отдал бы русский источник.
  if (!message || !(message.id in (runtimeIntl().messages ?? {}))) return null;
  return tr(message);
}

/** Текст реестра на языке интерфейса; нет в словаре или нет перевода — как пришёл. */
export function surfaceText(kind: SurfaceKind, text: string): string {
  return surfaceTextOrNull(kind, text) ?? text;
}
